<template>
  <div v-show="showScroll" class="footerTotop">
    <div class="footerTotop-link" @click.prevent="handleScrollToTop">
      <icon fas="fa-angle-up" class="footerTotop-link-icon" />
    </div>
  </div>
</template>
<script>
import { scrollToTop } from '@/utils/ScrollTo'
export default {
  data() {
    return {
      scY: 0
    }
  },
  computed: {
    showScroll() {
      const scrollStart = this.$store.isSP ? 400 : 300
      return this.scY > scrollStart
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.scY = window.scrollY
    },
    handleScrollToTop() {
      scrollToTop()
    }
  }
}
</script>
<style scoped lang="scss">
.footerTotop {
  background: $black-1a;
  border-radius: 3px;
  float: right;
  opacity: 0.3;
  @include sp {
    width: 3.8rem;
    height: 3.8rem;
    right: 0;
  }
  @include pc {
    width: 3.2rem;
    height: 3.2rem;
    right: 1.2rem;
    bottom: 1.2rem;
  }
  bottom: 0;
  position: fixed;
  z-index: 1001;
  @include sp {
    margin-bottom: 7rem;
    margin-right: 1.5rem;
  }
  &-link {
    display: inline-block;
    position: relative;
    @include sp {
      top: 0.6rem;
      left: 1.2rem;
    }
    @include pc {
      top: 6px;
      left: 10px;
    }
    &-icon {
      @include sp {
        font-size: 2.3rem;
      }
      @include pc {
        font-size: 2rem;
      }
      color: $white;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
